import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderRuthPoems from "../../../../src/content/ruth-graham-love-poems/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderRuthPoems,
  React
};